import { useQuery } from "@tanstack/react-query"

import { QUERY_KEYS } from "../../constants"
import { getChildQuestions } from "../../util/questionnaires"
import { loadQuestionnaires } from "../user"

export const useChildQuestionnairesQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.QUESTIONNAIRES],
    queryFn: loadQuestionnaires,
    select: getChildQuestions,
  })
}
